import StudentCareServices from '../../../services/StudentCareServices';

export default {
  data() {
    return {};
  },
  computed: {},
  methods: {
    generateCss(hex) {
      if (!hex) return '';
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex.substring(0, 7));
      return result ? `background: rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, 0.15); border: 1px solid ${hex}; color: ${hex}` : '';
    },
    async copyMobile(item) {
      const result = await StudentCareServices.getMobile(item.id);
      if (result && result.success) {
        navigator.clipboard.writeText(result.data).then(
          () => {
            this.$swal({
              type: 'success',
              icon: 'success',
              showConfirmButton: false,
              toast: true,
              timer: 1000,
              title: 'Sao chép thành công!',
              position: 'top',
            });
          },
        );
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi',
          text: result.message,
        });
      }
    },
  },
};
